import { useAuth } from "@/lib/auth";
import FarmerDashboard from "@/components/dashboards/FarmerDashboard";
import DriverDashboard from "@/components/dashboards/DriverDashboard";
import ClientDashboard from "@/components/dashboards/ClientDashboard";
import WholesaleDashboard from "@/components/dashboards/WholesaleDashboard";
import AdminDashboard from "@/components/dashboards/AdminDashboard";
import EnablePushNotifications from "@/components/EnablePushNotifications";
import ContactSupportDialog from "@/components/ContactSupportDialog";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-10">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-emerald-800 font-semibold">{user.role} Dashboard</div>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl text-stone-900">Welcome back, {user.name?.split(" ")[0]}.</h1>
          {user.state && <p className="mt-2 text-stone-500 font-sans text-sm">{user.state}</p>}
        </div>
        {user.verified && (
          <div className="px-4 py-2 bg-emerald-800/10 text-emerald-800 text-xs uppercase tracking-[0.2em] rounded-md font-semibold">Verified</div>
        )}
        <div className="sm:ml-auto flex items-center gap-2 flex-wrap">
          {user.role !== "admin" && <ContactSupportDialog />}
          <EnablePushNotifications />
        </div>
      </div>

      {user.role === "farmer" && <FarmerDashboard />}
      {user.role === "driver" && <DriverDashboard />}
      {user.role === "client" && <ClientDashboard />}
      {user.role === "wholesale" && <WholesaleDashboard />}
      {user.role === "admin" && <AdminDashboard />}
    </div>
  );
}
